/* hl-cart-discount — the Estimated total opens to show what it is made of.

   Replaces the standalone Discount row, 2026-09-23. Owner: "bỏ hẳn discount part
   luôn" and "khi click estimate total thì dropdown những thành phần".

   So there is one row in the summary instead of two or three, and the breakdown
   is behind it rather than beside it.

   THE SAVING HAS TO BE GATHERED FROM TWO PLACES. Shopify renders the same
   automatic discount differently depending on the tier — measured on this store,
   adding one unit at a time:

       1 unit   nothing
       2 units  ul.cart-items__discounts on each LINE, no summary row at all
       3 units  ul.cart-discounts in the SUMMARY, nothing on the lines

   This reads whichever exists. */
(function () {
  /* OPEN AND MARKED WHEN THERE IS A SAVING — preview 2026-10-08, owner: "Auto
     dropdown discount trong phần estimate totals khi có discount và làm nổi bật
     lên". Every cart since 2026-10-10 (owner: "estimate total trong cart drawer
     phải tự expand nếu có giảm giá"); it was the board's carts only before.
     The shopper's own tap wins: once they close it, it stays closed until the
     discount itself changes. */
  var userOpen = null;      // null = never touched; true/false = their last tap
  var lastSaving = '';

  var MONEY = /-?[^\d\s]{0,3}\s?[\d.,]+/;

  function amount(text) {
    var m = String(text || '').replace(/[()]/g, '').match(MONEY);
    if (!m) return null;
    var n = parseFloat(m[0].replace(/[^\d.,-]/g, '').replace(/,/g, ''));
    return isNaN(n) ? null : Math.abs(n);
  }

  function symbolOf(text) {
    /* U+2212 excluded alongside the hyphen, or a minus sign is read as part of
       the currency symbol and every figure comes back negative. */
    var m = String(text || '').replace(/[−-]/g, '').match(/[^\d\s.,()]+/);
    return m ? m[0] : '$';
  }

  function money(sym, n) { return sym + n.toFixed(2); }

  var CARET = '<svg class="hl-ct-sum__caret" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
              '<path d="M4 6.5L8 10.5L12 6.5" stroke="currentColor" stroke-width="1.5"' +
              ' stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function tagIcon(drawer) {
    var src = drawer.querySelector('.cart-discounts__label svg, .cart-items__discount-icon svg');
    return src ? src.outerHTML : '';
  }

  /* Every saving, grouped by the name it was given: two lines carrying the same
     "Buy 2 Save 10%" are one discount, not two. */
  function collect(drawer) {
    var out = { total: 0, sym: '$', names: [], by: {} };

    function add(label, value, raw) {
      if (value === null || !label) return;
      out.sym = symbolOf(raw) || out.sym;
      if (!(label in out.by)) { out.by[label] = 0; out.names.push(label); }
      out.by[label] += value;
      out.total += value;
    }

    var rows = drawer.querySelectorAll('.cart-drawer__summary .cart-discounts__item');
    if (rows.length) {
      for (var i = 0; i < rows.length; i++) {
        var v = rows[i].querySelector('.cart-discounts__value');
        var l = rows[i].querySelector('.cart-discounts__label');
        add(l ? l.textContent.replace(/\s+/g, ' ').trim() : '',
            amount(v ? v.textContent : null), v ? v.textContent : '');
      }
      return out;
    }

    var lines = drawer.querySelectorAll('.cart-items__discounts li');
    for (var j = 0; j < lines.length; j++) {
      var av = lines[j].querySelector('.cart-items__discount-amount');
      add(lines[j].textContent.replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim(),
          amount(av ? av.textContent : null), av ? av.textContent : '');
    }
    return out;
  }

  function render() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var totals = drawer.querySelector('.cart-totals');
    if (!totals) return;

    var nativeTotal = totals.querySelector('.cart-totals__total');
    var valueEl = totals.querySelector('.cart-totals__total-value');
    if (!nativeTotal || !valueEl) return;

    var raw = (valueEl.getAttribute('value') || valueEl.textContent || '').trim();
    var charged = amount(raw);
    if (charged === null) return;
    /* The currency code the theme prints after the figure, kept as written
       rather than assumed — a store that switches presentment currency would
       otherwise keep saying USD. */
    var curMatch = raw.match(/([A-Z]{3})\s*$/);
    var cur = curMatch ? curMatch[1] : '';

    var d = collect(drawer);
    /* Subtotal derived as charged + saved rather than read: at two units the
       theme renders no subtotal row at all, so there is nothing to read. */
    var subtotal = d.total ? charged + d.total : null;

    var key = [charged.toFixed(2), cur, d.total.toFixed(2),
               d.names.map(function (n) { return n + ':' + d.by[n].toFixed(2); }).join(',')].join('|');

    var existing = totals.querySelector('.hl-ct-sum');
    if (existing && existing.dataset.hlKey === key) return;

    /* Rebuilding closes the disclosure, and the cart re-renders on every
       quantity change — a shopper who opened the breakdown should not have it
       shut under them. */
    var wasOpen = existing ? existing.hasAttribute('open') : false;
    if (existing) existing.remove();

    var auto = d.total > 0;
    var savingKey = d.total.toFixed(2) + '|' + d.names.join(',');
    var savingChanged = auto && savingKey !== lastSaving;
    if (savingChanged) userOpen = null;   // a new saving is news again
    lastSaving = d.total > 0 ? savingKey : '';
    if (auto) wasOpen = userOpen === null ? true : userOpen;

    var el = document.createElement('details');
    el.className = 'hl-ct-sum';
    el.dataset.hlKey = key;
    if (wasOpen) el.setAttribute('open', '');

    var struck = subtotal === null ? ''
      : '<s class="hl-ct-sum__was">' + money(d.sym, subtotal) + '</s>';

    el.innerHTML =
      '<summary class="hl-ct-sum__row">' +
        '<span class="hl-ct-sum__label"><span></span>' + CARET + '</span>' +
        '<span class="hl-ct-sum__value">' + struck +
          '<b class="hl-ct-sum__now"></b>' +
          (cur ? '<span class="hl-ct-sum__cur"></span>' : '') +
        '</span>' +
      '</summary>' +
      '<ul class="hl-ct-sum__list"></ul>';

    el.querySelector('.hl-ct-sum__label span').textContent = 'Estimated total';
    if (auto) {
      el.classList.add('hl-ct-sum--saving');
      if (savingChanged) el.classList.add('is-new');
    }
    el.querySelector('.hl-ct-sum__now').textContent = money(d.sym, charged);
    if (cur) el.querySelector('.hl-ct-sum__cur').textContent = cur;

    var ul = el.querySelector('.hl-ct-sum__list');
    function line(label, value, icon) {
      var li = document.createElement('li');
      li.className = 'hl-ct-sum__item';
      li.innerHTML = '<span class="hl-ct-sum__tag">' + (icon || '') + '</span>' +
                     '<span></span><b></b>';
      li.querySelectorAll('span')[1].textContent = label;
      li.querySelector('b').textContent = value;
      ul.appendChild(li);
    }

    if (subtotal !== null) line('Subtotal', money(d.sym, subtotal), '');
    var icon = tagIcon(drawer);
    d.names.forEach(function (n) {
      line(n, '−' + money(d.sym, d.by[n]), icon);
      if (auto) ul.lastChild.classList.add('hl-ct-sum__item--off');
    });
    /* With no discount there is nothing to break down, so the row is a row and
       not a disclosure — a caret that opens on an empty list is a broken
       promise. */
    if (!ul.children.length) {
      el.classList.add('hl-ct-sum--flat');
      el.removeAttribute('open');
    }

    el.querySelector('summary').addEventListener('click', function () {
      // the click runs before the toggle, so the new state is the opposite
      userOpen = !el.hasAttribute('open');
    });

    nativeTotal.parentNode.insertBefore(el, nativeTotal);
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; render(); });
  }

  /* SYNCHRONOUS FOR DRAWER MUTATIONS, 2026-09-23. The theme's morph removes
     this row (it is not in the server HTML) and the rAF put it back one frame
     later — long enough to paint a summary 63px shorter, which the height
     animation in hl-cart-motion.js then played as a drop and a rise. The
     observer callback runs after the morph and before paint, so re-rendering
     there means no frame is ever painted without the row. Mutations outside
     the drawer are ignored instead of costing a frame's work each. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#cart-drawer')) {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          render();
          return;
        }
      }
    }).observe(document.body, { subtree: true, childList: true });
  }
  document.addEventListener('cart:update', schedule);
  document.addEventListener('shopify:cart:lines-update', schedule);
  schedule();
})();
